import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col } from "react-bootstrap"
import { useTranslation } from 'react-i18next';
import { ActionButton, TooltipHost, TooltipOverflowMode } from "@fluentui/react";
import SidePanelContractInformation from './SidePanelContractInformationBulk';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const PayContractInfo = (props) => {
    const { t } = useTranslation();
    const { 
        inputParam_HideHeader = false,
        inputParam_Contract = null
    } = props;

    const [isPanelContractInformationOpen, setIsPanelContractInformationOpen] = useState(false);

    const handlerOpenMoreInformationPanel = () => {
        setIsPanelContractInformationOpen(!isPanelContractInformationOpen)
    }
        
    const renderContent = () => {
        return <>
                    <Row className='py-2 me-1' style={{height: "25%"}}>
                        <Col>
                            <Row>
                                <Col className='col-auto' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-contractcode')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={inputParam_Contract.contractCode}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{inputParam_Contract.contractCode}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                                <Col className='ms-auto'>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-contractname')}</Col>
                                    </Row>
                                    <Row>
                                        <Col style={{fontSize: "14px", fontWeight: "normal"}}>{inputParam_Contract.name}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col className='col-auto my-auto'>
                            <Row>
                                <Col className='col-auto me-1' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-company')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={inputParam_Contract.legalEntityBuyerName}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{inputParam_Contract.legalEntityBuyerName}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                                <Col className='col-auto me-1' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    <Row>
                                        <Col style={{fontSize: "20px", fontWeight: "bolder"}}>{t('data-lang-lbl-comlabcompany')}</Col>
                                    </Row>
                                    <Row>
                                        <TooltipHost
                                            overflowMode={TooltipOverflowMode.Self}
                                            content={inputParam_Contract.legalEntitySupplierName}
                                        >
                                            <div style={{fontSize: "14px", fontWeight: "normal"}}>{inputParam_Contract.legalEntitySupplierName}</div>
                                        </TooltipHost>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
    }

    return (
            <Card className='board-element-form h-100'>
                {
                    !inputParam_HideHeader &&
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-contractinformation')}</b>
                            <ActionButton text='Más' onClick={handlerOpenMoreInformationPanel} iconProps={{iconName: "View"}} styles={{ icon: { fontSize: 20 } }} />
                        </Card.Title>
                    </Card.Header>
                }
                <Card.Body className='px-2 pt-2'>
                    {(inputParam_Contract) && renderContent()}
                </Card.Body>
                {
                    (isPanelContractInformationOpen && inputParam_Contract !== null) &&
                    <SidePanelContractInformation
                        isPanelOpen={ isPanelContractInformationOpen }
                        setterIsPanelOpen={ setIsPanelContractInformationOpen } 
                        inputParam_Contract={ inputParam_Contract } 
                    />
                }
            </Card>
    )
};

export default PayContractInfo;